import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busrentalforweddinginpimprichichwad() {



  const cardData =
  {
    keyword: 'Bus Rental for Wedding in Pimpri Chinchwad',
    heading: 'Sanavi Travels: Bus Rental for Wedding in Pimpri Chinchwad',
    headingDescription: 'Sanavi Travels offers reliable Bus Rental for Wedding in Pimpri Chinchwad, providing safe, comfortable, and convenient transportation for wedding guests, family members, and VIPs attending wedding events. Our fleet of well-maintained AC and non-AC buses, mini buses, and luxury coaches ensures spacious seating, smooth rides, and timely arrivals, making every wedding celebration hassle-free. With professional drivers, flexible full-day and multi-day wedding bus packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free transportation. We provide convenient pickup and drop services across Pimpri Chinchwad including Akurdi, Nigdi, Bhosari, Pimple Saudagar, Wakad, Hinjewadi, and surrounding areas, ensuring a seamless and memorable wedding experience. Choose Sanavi Travels for trusted wedding bus rental services in Pimpri Chinchwad, delivering comfort, reliability, and exceptional service for your special day.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is Pune’s iconic 18th-century fort built by the Peshwas, featuring massive stone walls, grand gateways like Delhi Darwaza, and spacious courtyards. Though partly destroyed by fire, it stands as a symbol of Maratha heritage and valor. The evening light-and-sound show narrates Pune’s royal history."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a historic monument tied to India’s freedom movement, where Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned. It now houses a museum displaying Gandhi’s personal artifacts and documents amidst serene gardens, making it a significant heritage site."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered Ganesh temple. The idol, adorned with gold ornaments, draws thousands of devotees daily. Ganesh Chaturthi sees grand celebrations, music, and cultural events, highlighting its spiritual and social significance."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, situated on a hilltop near Pune, is famous for the 1670 battle where Tanaji Malusare sacrificed his life for Shivaji Maharaj. Visitors can trek or drive to explore the fort, enjoy scenic Sahyadri views, and savor local delicacies like pithla-bhakri."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from basalt rock, it features monolithic pillars and a serene sanctum. Despite its urban location, it offers peace, meditation, and a glimpse into ancient craftsmanship."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts including traditional ornaments, musical instruments, and household antiques. The recreated Mastani Mahal is a highlight, offering cultural and historical insights into India’s heritage."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views after climbing 103 steps. The hilltop temple complex, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era and includes smaller shrines and a museum."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global center for meditation, wellness therapies, and mindfulness. Spread across landscaped gardens, it attracts visitors seeking relaxation, rejuvenation, and spiritual growth."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. With arched bridges, water streams, and manicured lawns, it is perfect for morning walks, family outings, and photography."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot near Pune. Surrounded by hills, it offers scenic views, especially during monsoon. Visitors enjoy picnics, sunset views, and local snacks, making it a favorite weekend destination."
  }
]
,




"services": [
  {
    "name": "Bus Rental for Wedding in Pimpri Chinchwad",
    "description": "Bus Rental for Wedding in Pimpri Chinchwad offers comfortable buses for wedding events and guest transport."
  },
  {
    "name": "Wedding Bus Hire PCMC",
    "description": "Wedding Bus Hire PCMC provides organized buses for weddings with professional drivers for smooth travel."
  },
  {
    "name": "AC Wedding Bus PCMC",
    "description": "AC Wedding Bus PCMC ensures a cool and comfortable ride with fully air-conditioned buses for wedding guests."
  },
  {
    "name": "Luxury Wedding Bus PCMC",
    "description": "Luxury Wedding Bus PCMC delivers premium buses with advanced comfort features for a stylish wedding journey."
  },
  {
    "name": "Marriage Bus Rental PCMC",
    "description": "Marriage Bus Rental PCMC provides reliable and spacious buses for transporting guests during wedding ceremonies."
  },
  {
    "name": "Guest Transport Bus PCMC",
    "description": "Guest Transport Bus PCMC offers organized bus travel for wedding attendees with punctual pickups and safe rides."
  },
  {
    "name": "Affordable Wedding Bus PCMC",
    "description": "Affordable Wedding Bus PCMC delivers budget-friendly buses for weddings without compromising comfort or safety."
  },
  {
    "name": "Chauffeur Driven Wedding Bus",
    "description": "Chauffeur Driven Wedding Bus ensures stress-free travel with professional drivers handling routes and schedules."
  },
  {
    "name": "Best Wedding Bus PCMC",
    "description": "Best Wedding Bus PCMC provides top-quality wedding buses with reliable service and well-maintained vehicles."
  },
  {
    "name": "Pimpri Chinchwad Wedding Bus Booking",
    "description": "Pimpri Chinchwad Wedding Bus Booking allows easy reservation of wedding buses with flexible pickup and drop options."
  },
  {
    "name": "Family Wedding Bus PCMC",
    "description": "Family Wedding Bus PCMC provides comfortable and spacious buses for families attending weddings."
  },
  {
    "name": "Event Bus Rental PCMC",
    "description": "Event Bus Rental PCMC offers organized buses for weddings, receptions, and other large celebrations."
  },
  {
    "name": "Reception Transport Bus PCMC",
    "description": "Reception Transport Bus PCMC provides reliable transport for guests attending wedding receptions and related events."
  },
  {
    "name": "Wedding Travel Bus PCMC",
    "description": "Wedding Travel Bus PCMC ensures comfortable and safe travel for wedding guests and family members."
  },
  {
    "name": "Local Wedding Bus PCMC",
    "description": "Local Wedding Bus PCMC delivers convenient bus services for wedding events within Pimpri Chinchwad."
  }
],
"tableData": [
  ["Bus Rental for Wedding in Pimpri Chinchwad", "Wedding Bus Hire PCMC"],
  ["AC Wedding Bus PCMC", "Luxury Wedding Bus PCMC"],
  ["Marriage Bus Rental PCMC", "Guest Transport Bus PCMC"],
  ["Affordable Wedding Bus PCMC", "Chauffeur Driven Wedding Bus"],
  ["Best Wedding Bus PCMC", "Pimpri Chinchwad Wedding Bus Booking"],
  ["Family Wedding Bus PCMC", "Event Bus Rental PCMC"],
  ["Reception Transport Bus PCMC", "Wedding Travel Bus PCMC"],
  ["Local Wedding Bus PCMC", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus Rental for Wedding in Pimpri Chinchwad with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides spacious and comfortable bus rentals for weddings in Pimpri Chinchwad, perfect for guest transportation, family groups, and wedding parties."
  },
  {
    "WhyChooseheading": "Well-Maintained and Clean Buses",
    "WhyChoosedescription": "Our buses are regularly serviced, air-conditioned, and thoroughly cleaned to ensure a smooth and hygienic ride for wedding events."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and familiar with Pimpri Chinchwad routes, ensuring timely and safe transportation for wedding guests."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides upfront pricing for wedding bus rentals, including fuel, driver allowances, and other charges with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, itinerary planning, and any last-minute changes for wedding transportation."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, half-day, full-day, or customized bus rental packages according to your wedding schedule and guest requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every wedding trip to ensure a safe and comfortable experience for guests."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for wedding bus rentals in Pimpri Chinchwad."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rentals for weddings in Pimpri Chinchwad?',
    answer: 'Yes, Sanavi Travels offers reliable bus rental services for weddings, including guest transportation and family groups in Pimpri Chinchwad.'
  },
  {
    question: 'How can I book a bus for a wedding in Pimpri Chinchwad?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for wedding transportation?',
    answer: 'Sanavi Travels provides air-conditioned, spacious, and well-maintained buses suitable for wedding events.'
  },
  {
    question: 'Are drivers experienced with Pimpri Chinchwad routes?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with local routes to ensure timely transportation for wedding guests.'
  },
  {
    question: 'Can I rent a bus for a few hours or a full day?',
    answer: 'Absolutely. We offer hourly, half-day, full-day, and custom packages to match your wedding schedule.'
  },
  {
    question: 'Are the buses sanitized before each trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before every wedding rental.'
  },
  {
    question: 'Is customer support available during the wedding transportation?',
    answer: 'Yes, our 24x7 customer support team is available throughout the wedding bus service.'
  },
  {
    question: 'What payment options are available for wedding bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is punctual service guaranteed for wedding bus rentals?',
    answer: 'Yes, Sanavi Travels ensures on-time pickups and reliable service for all wedding bus bookings in Pimpri Chinchwad.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Deshmukh',
    feedback: 'Booked a bus for wedding guests in Pimpri Chinchwad. Comfortable, clean, and the driver was very professional.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha Kulkarni',
    feedback: 'Excellent bus rental service for our wedding. Timely service, spacious buses, and helpful staff made it perfect.',
    rating: 5
  }
];































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Rental for Wedding in Pimpri Chinchwad - Sanavi Travels",
  "description": "Book buses for weddings in Pimpri Chinchwad with Sanavi Travels. AC and luxury buses for guest transport, family travel, marriage events, receptions, and comfortable chauffeur-driven wedding journeys.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Bus Rental for Wedding in Pimpri Chinchwad | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury buses in Pimpri Chinchwad for weddings with Sanavi Travels. Perfect for guest transport, family travel, marriage events, receptions, and safe chauffeur-driven wedding journeys."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/173.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busrentalforweddinginpimprichichwad;